import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useBlockNavigation = () => {
  const location = useLocation();

  useEffect(() => {
    window.history.pushState(null, "", window.location.href);

    const handlePopState = () => {
      window.history.pushState(null, "", window.location.href);
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [location]);
};

export default useBlockNavigation;